import React from "react";
import { createFileRoute, Outlet } from "@tanstack/react-router";
//
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
//
import { queryClient } from "@config/tanstack/tanstackQuery";
import { springHealthEligibileQueryOpts } from "src/backendApi/queries/spring-health-queries";
//
import { RouterLoadingComponent } from "@components/router-loading-component";

const springHealthRegisterSchema = z.object({
  spring_id: z.string().catch(""),
  email_address: z.string().catch(""),
});

export type SpringRegisterSearchParams = z.infer<
  typeof springHealthRegisterSchema
>;

export const Route = createFileRoute("/spring-health/register")({
  component: Outlet,
  validateSearch: zodValidator(springHealthRegisterSchema),
  pendingComponent: () => <RouterLoadingComponent bgColor="#00382D" />,
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    return await queryClient.ensureQueryData(
      springHealthEligibileQueryOpts({ ...deps }),
    );
  },
});
